module.exports = __webpack_public_path__ + "img/Slider-FeriadelTrabajo-2.936eabb6.jpg";